import getIntegrationPath from '../common/getIntegrationPath'
import getQueryUtils from '../common/getQueryUtils'
import getRjsConfig from './get-rjs-config'
import isLocal from '../common/isLocal'

/**
 * @param window
 * @param {{react:string,lodash:string,tweenmax:string}} versions
 * @param {boolean} experiment
 * @returns {getViewerRjsConfig}
 */
export default function (window, versions, experiment) {
  function getViewerRjsConfig(serviceTopology) {
    const local = isLocal(getQueryUtils(window).getParameterByName('ReactSource'))
    const rr = getRjsConfig(versions, serviceTopology, local)

    if (!experiment) {
      rr.paths.experiment = 'js/plugins/experiment/experiment'
    }

    // generated
    rr.packages = ['tpaIntegration', 'wixCodeIntegration', 'viewerIntegration'].map(packageName => ({
      name: packageName,
      main: packageName,
      location: getIntegrationPath(packageName, window.santaBase)
    }))

    return rr
  }
  return getViewerRjsConfig
}



// WEBPACK FOOTER //
// ./node_modules/santa-main-r/src/lib/viewer/rjs-config.js